import IconButton from "@mui/material/IconButton";

const ToggleIconButton = ({
  children,
  size = "small",
  sx,
  onClick,
  ...rest
}) => {
  return (
    <IconButton
      size={size}
      onClick={() => onClick((s) => !s)}
      sx={sx}
      {...rest}
    >
      {children}
    </IconButton>
  );
};

export default ToggleIconButton;
